var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var ReusableLogic_1;
/* eslint-disable import/no-duplicates */
import { Utils } from '@symon-ai/wisepipe-common';
import { DateConverter, JSON, JsonConverter, JsonSchemaV2 } from '@symon-ai/wisepipe-serialize';
import base64url from 'base64url';
import crypto from 'crypto';
import './graphElement'; // force import for JsonSchemaV2
import '@symon-ai/wisepipe-base-pipe'; // force import for JsonSchemaV2
import { ReusableLogicInputConfig } from './reusableLogicInputConfig';
import { reusableLogicSchemaValidation } from '../validations.generated';
const NAME_MAX_LENGTH = 100;
export const REUSABLE_LOGIC_PATH_SEPARATOR = '/';
export var ReusableLogicState;
(function (ReusableLogicState) {
    ReusableLogicState["Published"] = "Published";
    ReusableLogicState["Draft"] = "Draft";
})(ReusableLogicState || (ReusableLogicState = {}));
export var ReusableLogicParentType;
(function (ReusableLogicParentType) {
    ReusableLogicParentType["ReusableLogic"] = "ReusableLogic";
    ReusableLogicParentType["Pipe"] = "Pipe";
})(ReusableLogicParentType || (ReusableLogicParentType = {}));
export const reusableLogicSchema = {
    $id: 'urn:wisepipe-common-pipe:ReusableLogic',
    type: 'object',
    properties: {
        reusableLogicID: { type: 'string', uid: 9 },
        name: { type: 'string', minLength: 1, maxLength: NAME_MAX_LENGTH },
        elements: { type: 'array', items: { $ref: 'urn:wisepipe-common-pipe:GraphElement' } },
        directlyBigPipeCompatible: { type: 'boolean' },
        createdBy: { type: 'string' },
        createdAt: { type: 'string', format: 'date-time' },
        documentation: { $ref: 'urn:wisepipe-base-pipe:PipeDocumentation' },
        description: { type: 'string' },
        publishedVersionID: { type: 'string', uid: 9 },
        lastPublishedBy: { type: 'string' },
        lastPublishedTime: { type: 'string', format: 'date-time' },
        lastEditedTime: { type: 'string', format: 'date-time' },
        editorsSincePublish: {
            type: 'array',
            items: {
                type: 'object',
                properties: {
                    name: { type: 'string' },
                    id: { type: 'string' }
                }
            }
        },
        parameters: { type: 'array', items: { $ref: 'urn:wisepipe-base-pipe:ReusableLogicParameterDefinition' } },
        softDeleted: { type: 'boolean' },
        aiDescription: { type: 'string' }
    },
    required: [
        'reusableLogicID',
        'name',
        'directlyBigPipeCompatible',
        'createdAt',
        'createdBy',
        'publishedVersionID',
        'lastPublishedBy',
        'lastPublishedTime'
    ]
};
let ReusableLogic = ReusableLogic_1 = class ReusableLogic {
    constructor(reusableLogicID, name, directlyBigPipeCompatible, createdBy, createdAt, publishedVersionID, lastPublishedBy, lastPublishedTime, elements, lastEditedTime, description, parameters, documentation, editorsSincePublish, softDeleted, aiDescription) {
        this.reusableLogicID = reusableLogicID;
        this.name = name;
        this.elements = elements;
        this.directlyBigPipeCompatible = directlyBigPipeCompatible;
        this.createdBy = createdBy;
        this.createdAt = createdAt;
        this.publishedVersionID = publishedVersionID;
        this.lastPublishedBy = lastPublishedBy;
        this.lastPublishedTime = lastPublishedTime;
        this.lastEditedTime = lastEditedTime;
        this.parameters = parameters;
        this.description = description;
        this.documentation = documentation;
        this.editorsSincePublish = editorsSincePublish;
        this.softDeleted = softDeleted;
        this.aiDescription = aiDescription;
        JSON.validate(this, ReusableLogic_1);
    }
    static newID() {
        return Utils.newID(9);
    }
    static bufferID(reusableLogicID) {
        return Utils.base64StringToBuffer(reusableLogicID);
    }
    getElements() {
        return this.elements ?? [];
    }
    setElements(elements) {
        this.elements = elements;
    }
    static getIDPath(id, parentIDPath) {
        return `${parentIDPath ? `${parentIDPath}${REUSABLE_LOGIC_PATH_SEPARATOR}` : ''}${id}`;
    }
    static getElementIDForS3(elementID, reusableLogicParentNodeIDPath, isNodeRLInput) {
        if (reusableLogicParentNodeIDPath === undefined) {
            return elementID;
        }
        const idPath = ReusableLogic_1.getIDPath(elementID, reusableLogicParentNodeIDPath);
        return isNodeRLInput ? ReusableLogicInputConfig.appendRLInputToolOutputSuffix(idPath) : idPath;
    }
};
ReusableLogic.NAME_MAX_LENGTH = NAME_MAX_LENGTH;
ReusableLogic.getHashElementID = (elementID, parentNodePathID, suffix, isInParentPipe) => {
    if (!parentNodePathID || isInParentPipe)
        return elementID;
    const id = `${parentNodePathID}${REUSABLE_LOGIC_PATH_SEPARATOR}${elementID}${suffix ? REUSABLE_LOGIC_PATH_SEPARATOR + suffix : ''}`;
    const hash = crypto.createHash('sha256').update(id).digest('base64');
    return base64url.encode(hash.slice(0, 10));
};
__decorate([
    JsonConverter(new DateConverter('date-time'))
], ReusableLogic.prototype, "createdAt", void 0);
__decorate([
    JsonConverter(new DateConverter('date-time'))
], ReusableLogic.prototype, "lastPublishedTime", void 0);
__decorate([
    JsonConverter(new DateConverter('date-time'))
], ReusableLogic.prototype, "lastEditedTime", void 0);
ReusableLogic = ReusableLogic_1 = __decorate([
    JsonSchemaV2(reusableLogicSchema, reusableLogicSchemaValidation)
], ReusableLogic);
export { ReusableLogic };
//# sourceMappingURL=reusableLogic.js.map